enum DeviceStatus {
  Online = 'ONLINE',
  Offline = 'OFFLINE'
}

export default DeviceStatus;
